import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "397f31f4-83f2-4a1c-bb98-0f1041be9449",
    options: {
      image: `${config.ASSETS_URL}/02/10/task/task-01-chart-01.svg`,
    },
  },
  {
    id: "f8921e2b-d108-47e2-b131-0e83d2b5dd10",
    options: {
      image: `${config.ASSETS_URL}/02/10/task/task-01-chart-02.svg`,
    },
  },
  {
    id: "b40a39df-c90d-4932-9d28-06cdb915923d",
    options: {
      image: `${config.ASSETS_URL}/02/10/task/task-01-chart-03.svg`,
    },
  },
  {
    id: "c6d4784c-4e6e-4413-b63c-fae74dfbd01d",
    options: {
      image: `${config.ASSETS_URL}/02/10/task/task-01-chart-04.svg`,
    },
  },
];

export const task: Task = {
  id: "c94e28e3-454e-4e89-8171-2520266de247",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b40a39df-c90d-4932-9d28-06cdb915923d"],
};
